import { DirectiveBase } from '../angular-directive-base.directive';

/**
 * Displays a menu button containing a configured list of export format options which when clicked will allow an export action to be invoked
 */
export class ExportButton extends DirectiveBase {
  constructor() {
    super();
    this.restrict = 'E';
    this.scope = {
      exportFormats: '=',
      exportHandler: '&'
    };
    this.templateUrl = 'app/angularJS/components/export-button/export-button.html';
    this.controllerAs = 'vm',
    this.bindToController = true;
    this.controller = 'ExportButtonController';
  }
}